
import { onMounted, defineComponent, ref } from 'vue';
import { useList } from '@/hooks/use-list';
import { filters } from '@/core/plugins/filter';
import { getSysParamPageApi } from '@/api/sysparam';
import { DICTIONARY_STATUS_LIST, DICTIONARY_STATUS_ENUM } from './constant';
import type {
  GetSysParamPageApiReq as IParams,
  SysParamResItem as ListItem,
} from '@/api/sysparam/types';
import { usePermissionConfig } from './use-permission-config';
import OperationDialog from './components/operation-dialog.vue';

export default defineComponent({
  components: {
    OperationDialog,
  },
  setup() {
    const permissionConfig = usePermissionConfig();
    const {
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    } = useList<ListItem, IParams>({
      request: {
        api: getSysParamPageApi,
        params: {
          pageNum: '1',
          pageSize: '20',
        },
      },
    });

    const operationDialogVisible = ref(false);
    const operationTypeRef = ref('');
    const paramIdRef = ref('');

    const editSysParam = (paramId: string) => {
      paramIdRef.value = paramId;
      operationTypeRef.value = 'edit';
      operationDialogVisible.value = true;
    };

    const addSysParam = () => {
      paramIdRef.value = '';
      operationTypeRef.value = 'add';
      operationDialogVisible.value = true;
    };

    const previewSysParam = (paramId: string) => {
      paramIdRef.value = paramId;
      operationTypeRef.value = 'preview';
      operationDialogVisible.value = true;
    };

    onMounted(() => {
      handleSearch();
    });

    return {
      operationDialogVisible,
      operationTypeRef,
      paramIdRef,
      permissionConfig,
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
      filters,
      DICTIONARY_STATUS_LIST,
      DICTIONARY_STATUS_ENUM,
      editSysParam,
      addSysParam,
      previewSysParam,
    };
  },
});
